let isAddingFee = false;

window.addFeeAndCheckout = function (submitEvent) {
  if (isAddingFee) {
    return;
  }

  isAddingFee = true;

  const submitButton = submitEvent?.submitter || submitEvent?.currentTarget || submitEvent?.target?.querySelector('[type="submit"]');

  if (submitButton) {
    submitButton.setAttribute('disabled', true);
  }

  const resetState = () => {
    isAddingFee = false;
    if (submitButton) {
      submitButton.removeAttribute('disabled');
    }
  };

  const feeVariantId = theme.settings.feeVariantId;

  // If no fee variant configured, go straight to checkout
  if (!feeVariantId) {
    window.location.href = '/checkout';
    return;
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const feeItem = cart.items.find(item => item.variant_id == feeVariantId);

      if (feeItem && feeItem.quantity === 1) {
        window.location.href = '/checkout';
        return;
      }

      // update.js sets qty (idempotent) instead of adding – prevents double fee on concurrent calls
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: { [feeVariantId]: 1 } })
      })
        .then(response => response.json())
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error('Error adding fee:', error);
          window.location.href = '/checkout';
        });
    })
    .catch((error) => {
      console.error('Error:', error);
      window.location.href = '/checkout';
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('submit', (event) => {
      // We only want to intercept the main checkout button, not other submissions
      if (event.submitter && event.submitter.name === 'checkout') {
        event.preventDefault();
        window.addFeeAndCheckout(event);
      }
    });
  }
});
